import { Component } from '@angular/core';
import { ModulesApisService } from './services/modules-apis.service';
import { WebsocketService } from './services/websocket.service';
import { SwasthStorageService } from './storage/swasth-storage.service';
import { LoginAuthService } from './services/login-auth.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastController, Platform } from '@ionic/angular';
import firebase from 'firebase/compat/app';
import { SWASTH_CONST } from './constant';
import { JoinvideocallPage } from './joinvideocall/joinvideocall.page';
import { ModalController } from '@ionic/angular';
import { Network } from '@awesome-cordova-plugins/network/ngx';

const config = {
  apiKey: "AIzaSyAjNZDNJiDWa7E3ADeMZewHksNLA4qz4-c",
  authDomain: "swasth-plus.firebaseapp.com",
  databaseURL: "https://swasth-plus-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "swasth-plus",
  storageBucket: "swasth-plus.appspot.com",
  messagingSenderId: "75257375636",
  appId: "1:75257375636:web:6b7fc8d17d8775111c3d81",
  measurementId: "G-7FZDSD55K6"
};

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Book Appointment',
      url: '/book-appointment',
      icon: 'calendar'
    },
    {
      title: 'Appointments',
      url: '/view-booked-appointment',
      icon: 'reader'
    },
    // {
    //   title: 'Health Locker',
    //   // url: '/health-locker-prescription/33',
    //   url: '/healthlocker-tabs/health-locker-prescription/33',
    //   icon: 'medkit'
    // },
    {
      title: 'Profile',
      url: '/pt-profile',
      icon: 'person'
    },
    {
      title: 'Follow Up Circles',
      url: '/followup-circle-list',
      icon: 'person'
    },
    {
      title: 'Join New Circle',
      url: '/followup-find-circle',
      icon: 'person'
    },
    // {
    //   title: 'Webpush',
    //   url: '/video',
    //   icon: 'people'
    // },
    // {
    //   title: 'Chat',
    //   url: '/chatroom',
    //   icon: 'people'
    // }
    // {
    //   title: 'Add Family Members',
    //   url: '/subscribe-family-member',
    //   icon: 'people'
    // }

  ];
  autoRefreshFirstTime = false;
  OTP: any;
  OTPmessage: any;
  currentOtp: any;
  private resumesub1: any;
  doctorProfile: any;

  constructor(public authService: ModulesApisService,
    public webSocket: WebsocketService,
    public swStorage: SwasthStorageService,
    public loginAuth: LoginAuthService,
    public router: Router,
    private network: Network,
    public toastCtrl: ToastController, private modulesApis: ModulesApisService,
    private platform: Platform, private modalCtrl: ModalController,
  private route: ActivatedRoute) {
    //this.webSocketVideoCall();
    this.newVideoWebSocket();
    this.initializeApp();
    this.currentOtp = this.random();
    //this.answerVideoCall("Swasth","cpat02","drswasthdoctor3");
    // this.sendOtp();

    let disconnectSubscription = this.network.onDisconnect().subscribe(() => {
      console.log('network was disconnected :-(');
    });

    // stop disconnect watch
    disconnectSubscription.unsubscribe();

    // watch network for a connection
    let connectSubscription = this.network.onConnect().subscribe(() => {
      console.log('network connected!');
      setTimeout(() => {
        if (this.network.type === 'wifi') {
          console.log('we got a wifi connection, woohoo!');
        }
      }, 3000);
    });

    // stop connect watch
    connectSubscription.unsubscribe();

  }

  ngOnInit() {

    // let loginUserDetail:any;
    // this.platform.ready().then(() => {
    //   this.resumesub1 = this.platform.resume.subscribe(() => {
    //     this.swStorage.getStorage(this.loginAuth.LOGINUSER_PROFILE).then(logindata => {
    //       loginUserDetail = logindata; 
    //     this.webSocket.subcribe(loginUserDetail.userID,true);
    //     });
    //   });
    // });
  }

  ionViewDidLeave() {
    this.resumesub1.unsubscribe();
  }

  initializeApp() {
      const url = new URL(window.location.href);
      const razorpay_payment_id = url.searchParams.get('razorpay_payment_id');
      const razorpay_payment_link_id = url.searchParams.get('razorpay_payment_link_id');
      const razorpay_payment_link_reference_id = url.searchParams.get('razorpay_payment_link_reference_id');
      const razorpay_payment_link_status = url.searchParams.get('razorpay_payment_link_status');
      const razorpay_signature = url.searchParams.get('razorpay_signature');

      console.log(razorpay_payment_id);
      console.log(razorpay_payment_link_id);
      console.log(razorpay_payment_link_reference_id);
      console.log(razorpay_payment_link_status);
      console.log(razorpay_signature);
     
      if (razorpay_payment_id!=undefined)
      {
        this.router.navigate(['/payment-success'], { queryParams: { razorpay_payment_id, razorpay_payment_link_id, razorpay_payment_link_reference_id, razorpay_payment_link_status, razorpay_signature } });
      }
      else
      {
    let urlStr=window.location.href;
    // let urlStr="https://patientswasth.swasth.online/";
    
    let Uri = urlStr.split("/");
    console.log("url",Uri[2]);
    console.log("url",Uri[2].toString().split("."));
    let spltStr=Uri[2].toString().split(".");    
    let domain=spltStr[0];
    console.log("Tenant",domain);
    console.log("Tenant",domain.slice(7));    
    SWASTH_CONST.HOSPITALURLTENANT = domain.slice(7);
    
    // SWASTH_CONST.HOSPITALURLTENANT = "NUO";
    firebase.initializeApp(config);
      }
  }

  webSocketVideoCall() {
    this.webSocket.videocall.subscribe((data) => {
      //alert(this.videocallRedirection+","+this.appResume+","+this.autoRefreshFirstTime+","+this.notifReceived);
      if (data) {
        this.autoRefreshFirstTime = true;
        console.log("Video Call Web Socket==>", data);
        //alert("Video Call Websocket");
        //alert("Video Call Websocket");
        let loginUserDetail: any;
        let ptDetail: any;
        setTimeout(() => {
          this.swStorage.getStorage(this.loginAuth.LOGINUSER_PROFILE).then(logindata => {
            loginUserDetail = logindata;
            ptDetail = logindata;
            this.authService
              .getAgoraVideoDetailsByPatientuserid(loginUserDetail.userID)
              .subscribe(agoradata => {
                let agoraData: any = agoradata;
                if (agoraData != null) {
                  if (agoraData.status == "Active") {
                    this.presentToast("Incoming Call");
                    this.authService
                      .getDoctorProfile(data.docuid)
                      .subscribe(data => {
                        this.doctorProfile = data;
                        console.log("Doctor Profile==>", this.doctorProfile);
                      });
                    if (data.calltype == 'chatroom') {
                      setTimeout(() => {
                        this.router.navigate(["video", { circleCode: data.circlecode, ptuid: data.ptuid, docuid: data.docuid }]);
                      }, 500);
                    }
                    else {
                      setTimeout(() => {
                        //this.router.navigate(["waiting-room", { circleCode: data.circlecode, ptuid: data.ptuid, docuid: data.docuid }]);
                        //this.answerVideoCall(data.circlecode,data.ptuid,data.docuid);
                      }, 500);
                    }

                    setTimeout(() => {
                      this.autoRefreshFirstTime = false;
                    }, 5000);
                  }
                }
                else {
                  //this.presentToast("Call Missed");
                  alert("Call Missed");
                }
              });
          });
        }, 1000);

      }
    });
  }

  newVideoWebSocket() {
    this.webSocket.videocall.subscribe((data) => {
      // alert(this.autoRefreshFirstTime);
      if (data) {
        this.autoRefreshFirstTime = true;
        console.log("Video Call Web Socket==>", data);
        let meetLink = data.meetlink;
        let channel = data.channel;
        let circlecode = data.circlecode;
        let ptuserid = data.ptuid;
        let docuserid = data.docuid;
        this.authService
          .getDoctorProfile(data.docuid)
          .subscribe(data => {
            this.doctorProfile = data;
            console.log("Doctor Profile==>", this.doctorProfile);
          });
        this.authService
          .getAgoraVideoDetailsByPatientuserid(data.ptuid)
          .subscribe(agoradata => {
            let agoraData: any = agoradata;
            if (agoraData != null) {
              if (agoraData.status == "Active") {
                setTimeout(() => {
                  this.router.navigate(['/meeting'], { queryParams: { channel, meetLink, circlecode, ptuserid, docuserid } });
                  //this.router.navigate(["waiting-room", { circleCode: data.circlecode, ptuid: data.ptuid, docuid: data.docuid }]);
                  //this.answerVideoCall(data.circlecode,data.ptuid,data.docuid,meetLink,channel);
                }, 1000);
              }
              else {
                console.log("Call Not Active");
              }
            }
          });

        //this.router.navigate(['/meeting'], { queryParams: { channel, meetLink } });
      }
    });
  }

  async answerVideoCall(circlecode, ptuserid, docuserid, meetLink, channel) {
    const modal = await this.modalCtrl.create({
      component: JoinvideocallPage,
      cssClass: 'video-call-modal-css',
      componentProps: {
        doctorProfile: this.doctorProfile
      }
    });
    await modal.present();
    modal.onDidDismiss().then(data => {
      console.log("Call Modal", data);
      let videoCallDismissData: any = data;
      //alert(videoCallDismissData.data);
      if (videoCallDismissData.data == "videocall") {
        setTimeout(() => {
          //this.router.navigate(["video-appt-waiting-room", { circleCode: circlecode, ptuid: ptuserid, docuid: docuserid }]);
          this.router.navigate(['/meeting'], { queryParams: { channel, meetLink, circlecode, ptuserid, docuserid } });
        }, 500);
      }
    });
  }

  private async presentToast(message) {
    const toast = await this.toastCtrl.create({
      message,
      duration: 1000
    });
    toast.present();
  }

  sendOtp() {
    this.modulesApis.sendOtp('9159391976', this.currentOtp)
      .subscribe(sendotpres => {
        console.log("send otp response-->", sendotpres);
        alert("otp sent otp");

      });
  }

  async presentToastsms(message, position, duration) {
    const toast = await this.toastCtrl.create({
      message: message,
      position: position,
      duration: duration
    });
    toast.present();
  }

  random(): number {
    // let rand = Math.floor(Math.random() * 2000) + 1;
    let rand = Math.floor(100000 + Math.random() * 900000);
    return rand;
  }
}
